import { BodyText, Headline, Stack } from '@servicetitan/design-system';
import classNames from 'classnames';
import { FC } from 'react';
import * as Styles from './components.module.less';

export const AuthHeadline: FC<{ title: string; description?: string }> = ({
    description,
    title,
}) => (
    <Stack direction="column" className="m-b-3">
        <Headline className="ta-center" size="large">
            {title}
        </Headline>
        {!!description && (
            <BodyText className={classNames('c-neutral-200 ta-center', Styles.description)}>
                {description}
            </BodyText>
        )}
    </Stack>
);
